module.exports = __webpack_public_path__ + "img/bg_rocket_launch.a4293033.jpg";